import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export const carouselOptions = {
  dots: false,
  infinite: false,
  draggable: false,
  speed: 400,
  slidesToShow: 5,
  swipeToSlide: true,
  arrows: true,
  nextArrow: <Button icon={<RightOutlined />} />,
  prevArrow: <Button icon={<LeftOutlined />} />,
  responsive: [
    {
      breakpoint: 2000,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
};
